// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "vendor" + ".bundle.js?" + "7463ae4039294ac71fce" + "";
};